import Vue from 'vue'
import Router from 'vue-router'
import LandingPage from '@/views/LandingPage'
import Summoner from '@/views/Summoner'

Vue.use(Router)

export default new Router({
  mode: 'history',

  routes: [
    {
      path: '/',
      name: 'LandingPage',
      component: LandingPage,
    },
    {
      path: '/:region/:name',
      name: 'Summoner',
      component: Summoner,
      meta: {
        queue: 'solo',
      },
    },
    {
      path: '/:region/:name/flex',
      name: 'SummonerFlex',
      component: Summoner,
      meta: {
        queue: 'flex',
      },
    },
  ],
})



// WEBPACK FOOTER //
// ./src/router/index.js